import autoTable from "jspdf-autotable";

import {
    createReportLayout,
} from "./reportLayout";

import {
    drawInfoCard,
} from "./reportHelpers";

import InfoIcon from "../assets/info.png";
import VerifiedIcon from "../assets/verified.png";

export const exportRecruitmentReport = (
    driverPartner,
    drivers = [],
    milestones = []
) => {
    const statementId =
        `REC-${Date.now()}`;

    const generatedAt =
        new Date().toLocaleString();

    const doc =
        createReportLayout({
            title:
                "Recruitment Performance Statement",

            statementId,

            generatedAt,
        });

    /*
    -----------------------------------------
    SUMMARY
    -----------------------------------------
    */

   const approvedDrivers =
    drivers.filter(
        driver =>
            driver.driver
                ?.status ===
            "Approved"
    );

    const totalEarned =
        milestones
            .filter(
                (
                    milestone
                ) =>
                    milestone.commission_status ===
                    "Paid"
            )
            .reduce(
                (
                    total,
                    milestone
                ) =>
                    total +
                    Number(
                        milestone.commission_amount ||
                            0
                    ),
                0
            );

    const pendingEarnings =
        milestones
            .filter(
                (
                    milestone
                ) =>
                    milestone.commission_status ===
                    "Pending"
            )
            .reduce(
                (
                    total,
                    milestone
                ) =>
                    total +
                    Number(
                        milestone.commission_amount ||
                            0
                    ),
                0
            );

    /*
    -----------------------------------------
    PARTNER INFO
    -----------------------------------------
    */

    doc.setFontSize(
        8
    );

    doc.setTextColor(
        120
    );

    doc.text(
        "PARTNER NAME",
        15,
        75
    );

    doc.text(
        "REFERRAL CODE",
        85,
        75
    );

    doc.text(
        "TOTAL RECRUITS",
        145,
        75
    );

    doc.setFontSize(
        11
    );

    doc.setTextColor(
        20
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.text(
        driverPartner
            ?.user
            ?.username ||
            "-",
        15,
        82
    );

    doc.text(
        driverPartner?.partner_referral_code ||
            "-",
        85,
        82
    );

    doc.text(
        `${drivers.length}`,
        145,
        82
    );



    /*
    -----------------------------------------
    RECRUITMENT TABLE
    -----------------------------------------
    */



const recruitmentRows =
    drivers.map(
        driver => {
            const actualDriverId =
                driver.driver
                    ?.driver_id;

            const actualStatus =
                driver.driver
                    ?.status ||
                driver.status ||
                "-";

            const driverMilestones =
                milestones.filter(
                    milestone =>
                        milestone.driver_id ===
                        actualDriverId
                );

            const achievedMilestones =
                driverMilestones.filter(
                    milestone =>
                        milestone.milestone_status ===
                        "Achieved"
                );

            const totalDriverEarned =
                achievedMilestones.reduce(
                    (
                        total,
                        milestone
                    ) =>
                        total +
                        Number(
                            milestone.commission_amount ||
                                0
                        ),
                    0
                );

            return [
                driver.username ||
                    "-",

                driver.reference ||
                    "-",

                driver.created_at
                    ? new Date(
                          driver.created_at
                      ).toLocaleDateString()
                    : "-",

                actualStatus,

                `${achievedMilestones.length}/${driverMilestones.length}`,

                `P${totalDriverEarned.toFixed(
                    2
                )}`,
            ];
        }
    );

    autoTable(
        doc,
        {
            startY: 90,

            head: [
                [
                    "DRIVER",
                    "REFERENCE",
                    "REGISTERED",
                    "STATUS",
                    "PROGRESS",
                    "EARNED",
                ],
            ],

            body: [
                ...recruitmentRows,

                [
                    {
                        content:
                            "TOTAL RECRUITMENT EARNINGS",

                        colSpan: 5,

                        styles: {
                            halign:
                                "right",

                            fontStyle:
                                "bold",

                            fillColor:
                                [
                                    248,
                                    250,
                                    252,
                                ],
                        },
                    },

                    {
                        content: `P${totalEarned.toFixed(
                            2
                        )}`,

                        styles: {
                            halign:
                                "right",

                            fontStyle:
                                "bold",

                            textColor:
                                [
                                    36,
                                    83,
                                    255,
                                ],

                            fillColor:
                                [
                                    248,
                                    250,
                                    252,
                                ],

                            fontSize:
                                12,
                        },
                    },
                ],
            ],

            headStyles: {
                fillColor: [
                    232,
                    238,
                    255,
                ],

                textColor:
                    20,

                fontStyle:
                    "bold",
            },

            bodyStyles: {
                textColor:
                    40,

                fontSize:
                    9,
            },

            alternateRowStyles:
                {
                    fillColor:
                        [
                            252,
                            252,
                            252,
                        ],
                },

            styles: {
                lineColor:
                    [
                        235,
                        235,
                        235,
                    ],

                lineWidth:
                    0.2,
            },
        }
    );

    /*
    -----------------------------------------
    STATEMENT NOTES
    -----------------------------------------
    */

    const finalY =
        doc.lastAutoTable
            .finalY +
        15;

    doc.setDrawColor(
        220
    );

    doc.roundedRect(
        15,
        finalY,
        180,
        35,
        3,
        3
    );

    doc.setFontSize(
        10
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.setTextColor(
        40
    );

    doc.addImage(
        InfoIcon,
        "PNG",
        20,
        finalY + 5.6,
        5,
        5
    );

    doc.text(
        "STATEMENT NOTES",
        28,
        finalY +
            10
    );

    doc.setFontSize(
        9
    );

    doc.setFont(
        "helvetica",
        "normal"
    );

    doc.setTextColor(
        110
    );

    doc.text(
        [
            "This is a generated recruitment performance statement for the Mogoma Driver Partner Program.",
            "Recruitment statistics and referral milestone earnings are accurate as of the generated timestamp.",
            "For discrepancies please contact partner-support@mogoma.co.bw within",
            "5 business days of the statement date.",
        ],
        20,
        finalY +
            18
    );

    /*
    -----------------------------------------
    AUTHENTIC DOCUMENT
    -----------------------------------------
    */

    const authY =
        finalY + 48;

    doc.setTextColor(
        36,
        83,
        255
    );

    doc.setFontSize(
        11
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.addImage(
        VerifiedIcon,
        "PNG",
        20,
        authY - 4,
        5,
        5
    );

    doc.text(
        "AUTHENTIC DOCUMENT",
        28,
        authY
    );

    doc.setFontSize(
        8
    );

    doc.setFont(
        "helvetica",
        "normal"
    );

    doc.setTextColor(
        120
    );

    doc.text(
        [
            "Recotech (Pty) Ltd. | Tlokweng, Plot Z17A Sefoke Ward | Botswana | https://aigenix.co.bw/mogoma | +267 76 019 336",
            "This statement is electronically generated and remains valid without",
            "a physical signature.",
        ],
        20,
        authY + 8
    );

    /*
    -----------------------------------------
    BLUE FOOTER LINE
    -----------------------------------------
    */

    doc.setDrawColor(
        36,
        83,
        255
    );

    doc.setLineWidth(
        1
    );

    doc.line(
        15,
        authY + 25,
        195,
        authY + 25
    );

    doc.save(
        `Recruitment_Statement_${driverPartner?.partner_referral_code}.pdf`
    );
};